// NO EDITAR A MANO
import {IIdioma} from "services-comun/modules/net/idiomas";
import {ITraduccionLiteral, TraduccionLiteral} from "services-translation/modules/base/traduccion/literal";

import idiomas from "./_idiomas";

export class TraduccionCmpGdprAccept extends TraduccionLiteral {
    /* STATIC */
    protected static override readonly ID: string = "cmp.gdpr.accept";
    private static VALUES?: ITraduccionLiteral;

    public static override build(lang: IIdioma): TraduccionCmpGdprAccept {
        this.VALUES ??= this.completar({
            "valor": {
                "da": "Accepter",
                "de": "Akzeptieren",
                "en": "I agree",
                "es": "Aceptar",
                "fr": "Accepter",
                "it": "Accettare",
                "nl": "Accepteren",
                "pt": "Aceitar",
                "pt-BR": "Aceitar",
                "ru": "Принять",
                "ca": "Acceptar",
                "eu": "Onartu",
                "gl": "Aceptar",
                "fi": "Hyväksy",
                "hi": "स्वीकार करना",
                "hu": "Elfogad",
                "no": "Aksepter",
                "pl": "Akceptuj",
                "ro": "Acceptă",
                "cs": "Akceptovat",
                "sk": "Prijať",
                "sv": "Acceptera"
            }
        }, idiomas);

        return super.build(lang, this.VALUES);
    }

    /* INSTANCE */
}
